import React, { useEffect, useState } from 'react';
import { useParams , useNavigate} from 'react-router-dom';
import '../../Contact/Contact.css';
import './MemberProfile.css';
import { getBoardMemberById ,getExecutiveTeamById} from '../../../fetcher';

function MemberProfile() {
    const { id,type } = useParams();
    const navigate=useNavigate()
    const [boardMember, setBoardMember] = useState({});

    useEffect(() => {
        async function fetchMemberProfile() {
            let memberData
            try {
                if(type=='boardmember'){
                    memberData = await getBoardMemberById(id);
                }else{
                    memberData = await getExecutiveTeamById(id);
                }
                console.log(memberData);
                setBoardMember(memberData.records[0].fields);
            } catch (error) {
                console.error(error);
            }
        }
      
        fetchMemberProfile();
        window.scrollTo(0, 0);

    }, [id]);

    const handleback =()=>{
       navigate('/members')
    }

    const splitCompany = (company) => {
        if (!company) return [];
        return company.split(';');
    };

    return (
        <div className="profile-main-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <div className='profile-back' onClick={handleback}>
                <div className='backarrow'></div>
                <div className='backcontent'>
                    Back to Our Members
                </div>
            </div>
            <div className='profile-container'>
                <div className='photo-container'>
                    {boardMember.Photo && <img src={boardMember.Photo[0].url} className='profile-photo' />}
                </div>
                <div className='detail-container'>
                    {boardMember.Name && <div className='profile_name_detail'>{boardMember.Name}</div>}
                    {boardMember.Position && <div className='profile_position_detail'>{boardMember.Position}</div>}
                    {/* {boardMember.Company && <div className='profile_company_detail'>{boardMember.Company}</div>} */}
                    {boardMember.Company && (
                        <div>
                            {splitCompany(boardMember.Company).map((part, index) => (
                                <div  className='profile_company_detail' key={index}>{part}</div>
                            ))}
                        </div>
                    )}
                    <div className='profile-content-container'>
                        {boardMember.profile1 && <div className='profile_profile_detail'>{boardMember.profile1}</div>}
                        {boardMember.profile2 && <div className='profile_profile_detail'>{boardMember.profile2}</div>}
                        {boardMember.profile3 && <div className='profile_profile_detail'>{boardMember.profile3}</div>}
                        {boardMember.profile4 && <div className='profile_profile_detail'>{boardMember.profile4}</div>}
                        {boardMember.profile5 && <div className='profile_profile_detail'>{boardMember.profile5}</div>}

                    </div>
                </div>
            </div>
        </div>
    );
}

export default MemberProfile;
